import { render, staticRenderFns } from "./openclass-list(弃用）.vue?vue&type=template&id=2340c3bf"
import script from "./openclass-list(弃用）.vue?vue&type=script&lang=js"
export * from "./openclass-list(弃用）.vue?vue&type=script&lang=js"
import style0 from "./openclass-list(弃用）.vue?vue&type=style&index=0&id=2340c3bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports